import { Cascader as AntCascader } from "antd";
import { RenderInputProps } from "../types";
import { useFlow } from "../../../FlowEdit/useFlow";
import { useRequest } from "ahooks";
import { request } from "../../../../request";
import { ResponseCode } from "../../../../../constants";

type ItemType = {
  title: string;
  value: string;
  children: ItemType[];
};

type OptionType = {
  label: string;
  value: string;
  children: OptionType[];
};

export default function Cascader({ moduleId, item }: RenderInputProps) {
  const { updateNodeValue } = useFlow();
  const { data: opts = [] } = useRequest(async () => {
    if (item.request) {
      const rsp = await request<API.BaseResponse<ItemType[]>>(item.request);
      if (rsp.code === ResponseCode.Success) {
        function dfs(list: ItemType[]): OptionType[] {
          return list.map((item) => ({
            label: item.title,
            value: item.value,
            children: dfs(item.children || []),
          }));
        }
        return dfs(rsp.data || []);
      }
      return [];
    }
    return item.list as OptionType[];
  });

  return (
    <AntCascader
      defaultValue={item.value as string[]}
      onChange={(v: any) => {
        console.log(v);
        updateNodeValue(moduleId, item.key, v);
      }}
      options={opts}
      style={{ width: "100%" }}
      multiple={item.multiple as any}
      showCheckedStrategy="SHOW_CHILD"
    />
  );
}
